module.exports = "/assets/landing-cf/group-8.jpg?LF7cCR+";